/** @format */

import {useEffect} from "react";

export const useMountEffect = (fun, depends = []) => useEffect(fun, [fun, ...depends]);

export const onEnter = (event, callback) => event.key === "Enter" && callback();
